import { render, staticRenderFns } from "./CommentForSolutionRatingForm.vue?vue&type=template&id=79b40894&scoped=true"
import script from "./CommentForSolutionRatingForm.vue?vue&type=script&lang=js"
export * from "./CommentForSolutionRatingForm.vue?vue&type=script&lang=js"
import style0 from "./CommentForSolutionRatingForm.vue?vue&type=style&index=0&id=79b40894&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b40894",
  null
  
)

export default component.exports